module.exports = __webpack_public_path__ + "static/img/18.7e7b88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/18.png
// module id = 7gLr
// module chunks = 0